import React, { useState, useEffect } from "react";

export default function ResguardoForm() {
    const [personalList, setPersonalList] = useState([]);
    const [selectedPersonalId, setSelectedPersonalId] = useState("");
    const [softwareList, setSoftwareList] = useState([]);
    const [softwareSearch, setSoftwareSearch] = useState("");
    const [hardwareList, setHardwareList] = useState([]);
    const [hardwareSearch, setHardwareSearch] = useState("");
    const [verTodosHardware, setVerTodosHardware] = useState(false);
    const [verTodosSoftware, setVerTodosSoftware] = useState(false);
    const [almacenes, setAlmacenes] = useState([]);
    const [selectedAlmacenHW, setSelectedAlmacenHW] = useState("");

    const [formData, setFormData] = useState({
        titulo: "Resguardo de Equipo",
        fecha: new Date().toLocaleDateString("es-ES", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        }),
        solicitante: { nombre: "", depto: "", puesto: "" },
        equipo: { extension: "", estatus: "Propio" },
        cpu: {
            procesador: "",
            velocidad: "",
            memoria: "",
            nvme: "",
            unidad_optica: "",
            lector_memoria: "",
            config_ram: "",
        },
        hardware: [],
        software: [],
        bitacora: [],
        firmas: { recibio: "", autorizo: "Bonifacio Salinas Salinas", entrego: "" },
    });

    // ---------------------------
    // Cargar listas desde el backend
    // ---------------------------
    useEffect(() => {
        cargarPersonal();
        cargarSoftware();
        cargarHardware();
    }, []);

    const cargarPersonal = async () => {
        try {
            const response = await fetch("https://api.hmsaa.com.mx:5001/api/personales");
            if (response.ok) setPersonalList(await response.json());
        } catch (error) {
            console.error("Error al cargar personal:", error);
        }
    };

    const cargarSoftware = async () => {
        try {
            const response = await fetch("https://api.hmsaa.com.mx:5001/api/software");
            if (response.ok) setSoftwareList(await response.json());
        } catch (error) {
            console.error("Error al cargar software:", error);
        }
    };

    const cargarHardware = async () => {
        try {
            const response = await fetch("https://api.hmsaa.com.mx:5001/api/productos"); // tu endpoint hardware
            if (response.ok) setHardwareList(await response.json());
        } catch (error) {
            console.error("Error al cargar hardware:", error);
        }
    };
    useEffect(() => {
        fetch("https://api.hmsaa.com.mx:5001/api/almacenes")
            .then(res => res.json())
            .then(data => setAlmacenes(data))
            .catch(err => console.error(err));
    }, []);


    // ---------------------------
    // Manejo de selección de personal
    // ---------------------------
    const handlePersonalChange = (e) => {
        const personalId = e.target.value;
        setSelectedPersonalId(personalId);

        if (!personalId) {
            setFormData((prev) => ({
                ...prev,
                solicitante: { nombre: "", depto: "", puesto: "" },
                equipo: { ...prev.equipo, extension: "" },
                firmas: { ...prev.firmas, recibio: "" },
            }));
            return;
        }

        const personal = personalList.find((p) => p.id === parseInt(personalId));
        if (personal) {
            setFormData((prev) => ({
                ...prev,
                solicitante: {
                    nombre: personal.nombre,
                    depto: personal.departamento,
                    puesto: personal.puesto,
                },
                equipo: { ...prev.equipo, extension: personal.extension },
                firmas: { ...prev.firmas, recibio: personal.nombre },
            }));
        }
    };

    // ---------------------------
    // Helpers para actualizar estado
    // ---------------------------
    const handleChange = (path, value) => {
        setFormData((prev) => {
            const keys = path.split(".");
            const updated = JSON.parse(JSON.stringify(prev));
            let current = updated;
            for (let i = 0; i < keys.length - 1; i++) current = current[keys[i]];
            current[keys[keys.length - 1]] = value;
            return updated;
        });
    };

    const handleArrayChange = (arrayName, index, field, value) => {
        setFormData((prev) => {
            const updated = JSON.parse(JSON.stringify(prev));
            updated[arrayName][index][field] = value;
            return updated;
        });
    };

    // ---------------------------
    // Agregar / Eliminar filas
    // ---------------------------

    const addBitacoraRow = () => {
        setFormData((prev) => ({
            ...prev,
            bitacora: [...prev.bitacora, { fecha: "", descripcion: "", encargado: "" }],
        }));
    };
    const removeBitacoraRow = (index) => {
        setFormData((prev) => ({
            ...prev,
            bitacora: prev.bitacora.filter((_, i) => i !== index),
        }));
    };

    // ---------------------------
    // Software dinámico con checkboxes
    // ---------------------------
    const handleSoftwareToggle = (softwareItem, isChecked) => {
        setFormData((prev) => {
            const updated = { ...prev };
            if (isChecked) {
                if (!updated.software.some((s) => s.id_software === softwareItem.id_software)) {
                    updated.software = [...updated.software, softwareItem];
                }
            } else {
                updated.software = updated.software.filter(
                    (s) => s.id_software !== softwareItem.id_software
                );
            }
            return updated;
        });
    };

    const filteredSoftwareList = softwareList.filter(
        (sw) =>
            sw.descripcion.toLowerCase().includes(softwareSearch.toLowerCase()) ||
            sw.fabricante.toLowerCase().includes(softwareSearch.toLowerCase())
    );

    // ---------------------------
    // Hardware dinámico con checkboxes
    // ---------------------------
    const handleHardwareToggle = (hwItem, isChecked) => {
        setFormData((prev) => {
            const updated = { ...prev };
            if (isChecked) {
                if (!updated.hardware.some((h) => h.id_producto === hwItem.id_producto)) {
                    updated.hardware = [
                        ...updated.hardware,
                        {
                            id_producto: hwItem.id_producto,
                            descripcion: hwItem.descripcion || "",
                            marca: hwItem.marca || "",
                            modelo: hwItem.modelo || "",
                            serie: hwItem.numero_serie || "",  // <- mapeo correcto
                        },
                    ];
                }
            } else {
                updated.hardware = updated.hardware.filter((h) => h.id_producto !== hwItem.id_producto);
            }
            return updated;
        });
    };


    const filteredHardwareList = hardwareList.filter(
        (hw) =>
            hw.descripcion.toLowerCase().includes(hardwareSearch.toLowerCase()) ||
            hw.marca.toLowerCase().includes(hardwareSearch.toLowerCase())
    );

    // ---------------------------
    // Transformar CPU a array para backend
    // ---------------------------
    const buildCpuArray = (cpuObj) => {
        const mapping = [
            ["Procesador", "procesador"],
            ["Velocidad", "velocidad"],
            ["Memoria", "memoria"],
            ["NVMe", "nvme"],
            ["Unidad óptica", "unidad_optica"],
            ["Lector de memoria", "lector_memoria"],
            ["Config RAM", "config_ram"],
        ];
        return mapping
            .map(([label, key]) => ({ atributo: label, valor: cpuObj?.[key] || "" }))
            .filter((item) => item.valor && String(item.valor).trim() !== "");
    };

    // ---------------------------
    // Generar PDF
    // ---------------------------
    const generarPDF = async () => {
        try {
            const payload = JSON.parse(JSON.stringify(formData));
            payload.cpu = buildCpuArray(formData.cpu);
            if (selectedPersonalId) payload.personal_id = parseInt(selectedPersonalId);

            const url = "https://api.hmsaa.com.mx:5001/api/generar-pdf-final";
            const response = await fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/pdf" },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const text = await response.text();
                console.error("Error del servidor:", response.status, text);
                alert(`Error al generar PDF: ${response.status}\nRevisa la consola`);
                return;
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = "resguardo_equipo.pdf";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.error("Error en generarPDF:", error);
            alert("Ocurrió un error al generar el PDF. Revisa la consola.");
        }
    };

    return (
        <div className="container mx-auto p-6 bg-white shadow-md rounded-lg">
            <h1 className="text-2xl font-bold text-center mb-6">{formData.titulo}</h1>

            {/* Información del Solicitante */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h2 className="text-lg font-semibold mb-4 border-b pb-2">Información del Solicitante</h2>

                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700">Seleccionar Personal</label>
                    <select
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        onChange={handlePersonalChange}
                        value={selectedPersonalId}
                    >
                        <option value="">Seleccionar personal...</option>
                        {personalList
                            .filter((emp) => !emp.is_disabled)
                            .map((emp) => (
                                <option key={emp.id} value={emp.id}>
                                    {emp.nombre} - {emp.departamento} ({emp.puesto})
                                </option>
                            ))}
                    </select>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {["nombre", "depto", "puesto"].map((field) => (
                        <div key={field}>
                            <label className="block text-sm font-medium text-gray-700">
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                            </label>
                            <input
                                type="text"
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                                value={formData.solicitante[field]}
                                onChange={(e) => handleChange(`solicitante.${field}`, e.target.value)}
                            />
                        </div>
                    ))}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Extensión</label>
                        <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={formData.equipo.extension}
                            onChange={(e) => handleChange("equipo.extension", e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Estatus del Equipo</label>
                        <select
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={formData.equipo.estatus}
                            onChange={(e) => handleChange("equipo.estatus", e.target.value)}
                        >
                            <option value="Propio">Propio</option>
                            <option value="Arrendado">Arrendado</option>
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Fecha</label>
                        <input
                            type="text"
                            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            value={formData.fecha}
                            onChange={(e) => handleChange("fecha", e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {/* Hardware */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold border-b pb-2">Hardware</h2>
                </div>

                {/* Filtro por Almacén */}
                <div className="mb-2">
                    <label className="block text-sm font-medium text-gray-700">Filtrar por Almacén</label>
                    <select
                        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                        value={selectedAlmacenHW}
                        onChange={(e) => setSelectedAlmacenHW(e.target.value)}
                    >
                        <option value="">Todos los almacenes</option>
                        {almacenes.map((almacen) => (
                            <option key={almacen.id_almacen} value={almacen.id_almacen}>
                                {almacen.nombre_almacen}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Buscador */}
                <input
                    type="text"
                    placeholder="Buscar hardware..."
                    className="mb-2 w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    value={hardwareSearch}
                    onChange={(e) => setHardwareSearch(e.target.value)}
                />

                {/* Lista filtrada */}
                <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-md p-2 bg-white">
                    {hardwareList
                        .filter(hw => {
                            // Filtrar por almacén usando id_almacen
                            const matchAlmacen =
                                !selectedAlmacenHW ||
                                hw.almacen_id === parseInt(selectedAlmacenHW) ||
                                hw.id_almacen === parseInt(selectedAlmacenHW);

                            // Filtrar por búsqueda (descripción, marca, modelo)
                            const matchSearch = `${hw.descripcion} ${hw.marca} ${hw.modelo}`
                                .toLowerCase()
                                .includes(hardwareSearch.toLowerCase());

                            return matchAlmacen && matchSearch;
                        })
                        .slice(0, verTodosHardware ? undefined : 2)
                        .map(hw => (
                            <div key={hw.id_producto} className="border-b border-gray-100 py-1 last:border-none">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={formData.hardware.some(h => h.id_producto === hw.id_producto)}
                                        onChange={e => handleHardwareToggle(hw, e.target.checked)}
                                        className="accent-blue-600"
                                    />
                                    <div className="flex flex-col text-sm flex-1">
                                        <span className="font-medium text-gray-800">{hw.descripcion}</span>
                                        <span className="text-gray-500">
                                            {hw.marca} — {hw.modelo} ({hw.almacen_nombre})
                                        </span>
                                    </div>
                                </label>
                            </div>
                        ))}

                    {/* Botón Ver todos / Ver menos */}
                    {hardwareList.filter(hw => {
                        const matchAlmacen =
                            !selectedAlmacenHW ||
                            hw.almacen_id === parseInt(selectedAlmacenHW) ||
                            hw.id_almacen === parseInt(selectedAlmacenHW);
                        const matchSearch = `${hw.descripcion} ${hw.marca} ${hw.modelo}`.toLowerCase()
                            .includes(hardwareSearch.toLowerCase());
                        return matchAlmacen && matchSearch;
                    }).length > 2 && (
                            <button
                                type="button"
                                className="mt-2 text-blue-600 text-sm"
                                onClick={() => setVerTodosHardware(!verTodosHardware)}
                            >
                                {verTodosHardware ? "Ver menos" : "Ver todos"}
                            </button>
                        )}
                </div>
            </div>


            {/* CPU */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h2 className="text-lg font-semibold border-b pb-2 mb-4">Datos Técnicos / CPU</h2>
                <div className="grid grid-cols-2 gap-4">
                    {[
                        ["Procesador", "procesador"],
                        ["Velocidad", "velocidad"],
                        ["Memoria", "memoria"],
                        ["NVMe", "nvme"],
                        ["Unidad óptica", "unidad_optica"],
                        ["Lector de memoria", "lector_memoria"],
                        ["Config RAM", "config_ram"],
                    ].map(([label, key]) => (
                        <div key={key} className="flex flex-col">
                            <label className="text-sm font-medium text-gray-700">{label}</label>
                            <input
                                type="text"
                                className="mt-1 p-2 border border-gray-300 rounded-md shadow-sm"
                                value={formData.cpu?.[key] || ""}
                                onChange={(e) =>
                                    setFormData((prev) => ({ ...prev, cpu: { ...prev.cpu, [key]: e.target.value } }))
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Software */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h2 className="text-lg font-semibold border-b pb-2 mb-4">Software Instalado</h2>
                <input
                    type="text"
                    placeholder="Buscar software..."
                    className="mb-2 w-full p-2 border border-gray-300 rounded-md shadow-sm"
                    value={softwareSearch}
                    onChange={(e) => setSoftwareSearch(e.target.value)}
                />
                <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-md p-2 bg-white">
                    {filteredSoftwareList.length === 0 ? (
                        <p className="text-gray-500 text-sm text-center py-4">No se encontraron resultados.</p>
                    ) : (
                        (verTodosSoftware ? filteredSoftwareList : filteredSoftwareList.slice(0, 2)).map((sw) => (
                            <label
                                key={sw.id_software}
                                className="flex items-center gap-2 py-1 border-b border-gray-100 last:border-none cursor-pointer"
                            >
                                <input
                                    type="checkbox"
                                    checked={formData.software.some((s) => s.id_software === sw.id_software)}
                                    onChange={(e) => handleSoftwareToggle(sw, e.target.checked)}
                                    className="accent-blue-600"
                                />
                                <div className="flex flex-col text-sm">
                                    <span className="font-medium text-gray-800">{sw.descripcion}</span>
                                    <span className="text-gray-500">{sw.fabricante} — v{sw.version}</span>
                                </div>
                            </label>
                        ))
                    )}
                </div>

                {/* Botón Ver todos / Ver menos */}
                {filteredSoftwareList.length > 2 && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm"
                        onClick={() => setVerTodosSoftware(!verTodosSoftware)}
                    >
                        {verTodosSoftware ? "Ver menos" : "Ver todos"}
                    </button>
                )}
            </div>

            {/* Bitácora */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold border-b pb-2">Mantenimiento / Bitácora</h2>
                    <button
                        onClick={addBitacoraRow}
                        className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
                    >
                        + Agregar Fila
                    </button>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-200">
                                <th className="border border-gray-300 p-2">Fecha</th>
                                <th className="border border-gray-300 p-2">Descripción</th>
                                <th className="border border-gray-300 p-2">Encargado</th>
                                <th className="border border-gray-300 p-2">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formData.bitacora.map((item, index) => (
                                <tr key={index}>
                                    {["fecha", "descripcion", "encargado"].map((field) => (
                                        <td className="border border-gray-300 p-1" key={field}>
                                            <input
                                                type="text"
                                                className="w-full p-1 border-none bg-transparent"
                                                value={item[field] || ""}
                                                onChange={(e) => handleArrayChange("bitacora", index, field, e.target.value)}
                                            />
                                        </td>
                                    ))}
                                    <td className="border border-gray-300 p-1 text-center">
                                        <button
                                            onClick={() => removeBitacoraRow(index)}
                                            className="px-2 py-1 bg-red-500 text-white rounded text-xs"
                                        >
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Firmas */}
            <div className="bg-gray-50 p-4 rounded-lg mb-6">
                <h2 className="text-lg font-semibold mb-4 border-b pb-2">Firmas</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    {["recibio", "entrego", "autorizo"].map((field) => (
                        <div key={field}>
                            <label className="block text-sm font-medium text-gray-700">
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                            </label>
                            <input
                                type="text"
                                className={`mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 ${field === "recibio" ? "bg-gray-100" : ""
                                    }`}
                                value={formData.firmas[field]}
                                readOnly={field === "recibio"}
                                onChange={(e) => handleChange(`firmas.${field}`, e.target.value)}
                            />
                            <div className="text-center mt-2 border-t border-gray-400 pt-1">Firma</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Botón Generar PDF */}
            <div className="mt-6 flex justify-center">
                <button
                    onClick={generarPDF}
                    className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md shadow-sm hover:bg-blue-700"
                >
                    Generar PDF
                </button>
            </div>
        </div>
    );
}
